import { useLazyQuery } from '@apollo/client';
import { IQueryResult, IVariables } from './interfaces';
import { qualityReturnReceiptQuery } from './gql';

export const useQualityReturnReceiptGql = () => {
  const [runQualityReturnReceiptGql, { loading, data, error }] = useLazyQuery<IQueryResult, IVariables>(
    qualityReturnReceiptQuery,
    {
      context: {
        headers: {
          userFunctionKey: 'a684eceee76fc522773286a895bc8436'
        }
      }
    }
  );

  return {
    runQualityReturnReceiptGql,
    loadingQualityReturnReceipt: loading,
    dataQualityReturnReceipt: data?.qualityReturnReceipt,
    errorQualityReturnReceipt: error
  };
};
